import styled from 'styled-components';
import { OriginationSource } from '~/typings/graphql';

interface HeaderWrapperProps {
  entity?: string;
}

export const HeaderWrapper = styled.div<HeaderWrapperProps>`
  padding: 20px 100px;
  display: flex;
  justify-content: flex-start;
  align-items: center;

  ${props => props.theme.media.tabletLandscapeUp} {
    padding: 48px 160px;
  }

  ${props => props.theme.media.tabletPortraitDown} {
    padding: 24px 24px 24px;
    justify-content: space-between;
  }

  ${({ entity }) =>
    entity === OriginationSource.PerchEnergy &&
    `
    ${props => props.theme.media.tabletLandscapeUp} {
      padding: 32px;
    }
  `}
`;

export const SubContainer = styled.div`
  display: flex;
  align-items: center;
  margin-left: 24px;
  ${props => props.theme.media.tabletPortraitDown} {
    display: none;
  }
`;
